export const THIRDPARTY_SIGNUP_LOGIN = 'thirdparty_signup_login';
